import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
  selector: 'app-contact-us-block',
  templateUrl: './contact-us-block.component.html',
  styleUrls: ['./contact-us-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsBlockComponent {

  private _title: string = '';
  private _content: string = '';


  get title(): string {
    return this._title;
  }

  @Input({required: true})
  set title(value: string) {
    this._title = value;
  }

  get content(): string {
    return this._content;
  }

  @Input({required: true})
  set content(value: string) {
    this._content = value;
  }
}
